import { render, staticRenderFns } from "./HsabExpensePaymentDetails.vue?vue&type=template&id=4b4dc707&scoped=true"
import script from "./HsabExpensePaymentDetails.vue?vue&type=script&lang=ts"
export * from "./HsabExpensePaymentDetails.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpensePaymentDetails.vue?vue&type=style&index=0&id=4b4dc707&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dc707",
  null
  
)

export default component.exports